import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import { getGlobalAroConfig } from '@/utils/common';

import ProductList from '@/views/product/list'
import ProductList15Per from '@/views/product/list15Per'
import ProductListNtc from '@/views/product/listNtc'
import ProductListAroOnly from '@/views/product/listAroOnly'
import ProductDetail from '@/views/product/detail'
import AroList from '@/views/my/aro/list'
import AroDetail from '@/views/my/aro/detail'
import AroCancel from '@/views/my/aro/cancel'
import AroHistoryList from '@/views/my/aro/historyList'
import AroHistoryDetail from '@/views/my/aro/historyDetail'
import FourPlusList from '@/views/my/aro/fourPlusList'
import FourPlusDetail from '@/views/my/aro/fourPlusDetail'
import NtcCurrentList from '@/views/my/ntc/currentList'
import NtcCurrentDetail from '@/views/my/ntc/currentDetail'
import NtcCancel from '@/views/my/ntc/cancel'
import NtcCancelAgree from '@/views/my/ntc/cancelAgree'
import NtcHistoryList from '@/views/my/ntc/historyList'
import NtcHistoryDetail from '@/views/my/ntc/historyDetail'
import AgelocCurrentList from '@/views/my/ageloc/currentList'
import AgelocCurrentDetail from '@/views/my/ageloc/currentDetail'
import AgelocWithdraw from '@/views/my/ageloc/withdraw'
import AgelocHistoryList from '@/views/my/ageloc/historyList'
import AgelocHistoryDetail from '@/views/my/ageloc/historyDetail'
import ProductBasket from '@/views/product/basket'
import ProductPayment from '@/views/product/payment'
import ProductResult from '@/views/product/result'
import MemberShip from '@/views/my/njoy/memberShip'
import VipList from '@/views/my/njoy/vipList'
import VipDetail from '@/views/my/njoy/vipDetail'

import FourplusIntroduce01 from '@/views/info/fourplusIntroduce01'
import FourplusIntroduce02 from '@/views/info/fourplusIntroduce02'
import FourplusIntroduce03 from '@/views/info/fourplusIntroduce03'
import FourplusIntroduce04 from '@/views/info/fourplusIntroduce04'
import FourplusIntroduce05 from '@/views/info/fourplusIntroduce05'
// import FifteenthIntroduce from '@/views/info/fifteenthIntroduce'
// import SmartBeautyIntroduce from '@/views/info/smartBeautyIntroduce'
import NourishIntroduce from '@/views/info/nourishIntroduce'

//Add cart integration
import PopupAddInAroCart from '@/views/integration/popupAddInAroCart'

//Search Product List integration
import SearchProductList from '@/views/integration/searchProductList'

import AroLogin from '@/views/my/aro/aroLogin'
import AroLogout from '@/views/my/aro/aroLogout'



const artConfig = getGlobalAroConfig();
const basePath = artConfig.aroBaseUrl;

const MAIN_ARO_ROUTES = [

  {
    path: basePath+'/aroLogin',
    name: 'aroLogin',
    component: AroLogin,
    productionAvailable:false,
  },
  {
    path: basePath+'/aroLogout',
    name: 'aroLogout',
    component: AroLogout,
    productionAvailable:false,
  },



  {
    path: basePath+'/',
    name: 'index',
    component: ProductList
  },
  {
    path: basePath+'/list',
    name: 'productList',
    component: ProductList,
    props: (route) => ({
      division_code: route.query.division_code,
      big_classcodes: route.query.big_classcodes,
      fourpone:route.query.fourpone
    })
  },
  {
    path: basePath+'/list15Per',
    name: 'productList15Per',
    component: ProductList15Per
  },
  {
    path: basePath+'/listNtc',
    name: 'productListNtc',
    component: ProductListNtc
  },
  {
    path: basePath+'/listAroOnly',
    name: 'ProductListAroOnly',
    component: ProductListAroOnly
  },
  {
    path: basePath+'/detail/:pd_id',
    name: 'productDetail',
    component: ProductDetail,
    props: (route) => ({
      pd_type : route.query.pd_type,
      ref_title : route.query.ref_title
    }),
  },
  {
    path: basePath+'/basket',
    name: 'productBasket',
    component: ProductBasket
  },
  {
    path: basePath+'/payment',
    name: 'productPayment',
    component: ProductPayment,
    props: (route) => ({
      mode: route.query.mode,
      uspan_yn: route.query.uspan_yn,
      uspancode: route.query.uspancode,
    })
  },
  {
    path: basePath+'/aroList',
    name: 'aroList',
    component: AroList
  },
  {
    path: basePath+'/aroDetail',
    name: 'aroDetail',
    component: AroDetail,
    props: (route) => ({
      aro_no: route.query.aro_no
    })
  },
  {
    path: basePath+'/aroCancel',
    name: 'aroCancel',
    component: AroCancel,
    props: (route) => ({
      aro_no: route.query.aro_no
    })
  },
  {
    path: basePath+'/aroHistoryList',
    name: 'aroHistoryList',
    component: AroHistoryList
  },
  {
    path: basePath+'/aroHistoryDetail',
    name: 'aroHistoryDetail',
    component: AroHistoryDetail,
    props: (route) => ({
      aro_no: route.query.aro_no,
      aro_order_no: route.query.aro_order_no
    })
  },
  {
    path: basePath+'/fourPlusList',
    name: 'fourPlusList',
    component: FourPlusList
  },
  {
    path: basePath+'/fourPlusDetail',
    name: 'fourPlusDetail',
    component: FourPlusDetail
  },
  {
    path: basePath+'/ntcCurrentList',
    name: 'ntcCurrentList',
    component: NtcCurrentList
  },
  {
    path: basePath+'/ntcCurrentDetail',
    name: 'ntcCurrentDetail',
    component: NtcCurrentDetail
  },
  {
    path: basePath+'/ntcCancel',
    name: 'ntcCancel',
    component: NtcCancel
  },
  {
    path: basePath+'/ntcCancelAgree',
    name: 'ntcCancelAgree',
    component: NtcCancelAgree
  },
  {
    path: basePath+'/ntcHistoryList',
    name: 'ntcHistoryList',
    component: NtcHistoryList
  },
  {
    path: basePath+'/ntcHistoryDetail',
    name: 'ntcHistoryDetail',
    component: NtcHistoryDetail,
    props: (route) => ({
      ntc_no: route.query.ntc_no,
      web_order: route.query.web_order
    })
  },
  {
    path: basePath+'/agelocCurrentList',
    name: 'agelocCurrentList',
    component: AgelocCurrentList
  },
  {
    path: basePath+'/agelocCurrentDetail',
    name: 'agelocCurrentDetail',
    component: AgelocCurrentDetail,
    props: (route) => ({
      adr_no: route.query.adr_no,
    })
  },
  {
    path: basePath+'/agelocWithdraw',
    name: 'agelocWithdraw',
    component: AgelocWithdraw,
    props: (route) => ({
      adr_no: route.query.adr_no,
    })
  },
  {
    path: basePath+'/agelocHistoryList',
    name: 'agelocHistoryList',
    component: AgelocHistoryList,
    props: (route) => ({
      reqStartDate : route.query.reqStartDate,
      reqEndDate : route.query.reqEndDate,
    })
  },
  {
    path: basePath+'/agelocHistoryDetail',
    name: 'agelocHistoryDetail',
    component: AgelocHistoryDetail,
    props: (route) => ({
      adr_no: route.query.adr_no,
      adr_order_no: route.query.adr_order_no,
      reqStartDate : route.query.reqStartDate,
      reqEndDate : route.query.reqEndDate,
    })
  },
  {
    path: basePath+'/memberShip',
    name: 'memberShip',
    component: MemberShip
  },
  {
    path: basePath+'/vipList',
    name: 'vipList',
    component: VipList
  },
  {
    path: basePath+'/vipDetail',
    name: 'vipDetail',
    component: VipDetail
  },

  /* 소개 페이지*/
  {
    path: basePath+'/fourplusIntroduce01',
    name: 'fourplusIntroduce01',
    component: FourplusIntroduce01
  },
  {
    path: basePath+'/fourplusIntroduce02',
    name: 'fourplusIntroduce02',
    component: FourplusIntroduce02
  },
  {
    path: basePath+'/fourplusIntroduce03',
    name: 'fourplusIntroduce03',
    component: FourplusIntroduce03
  },
  {
    path: basePath+'/fourplusIntroduce04',
    name: 'fourplusIntroduce04',
    component: FourplusIntroduce04
  },
  // {
  //   path: basePath+'/fourplusIntroduce05',
  //   name: 'fourplusIntroduce05',
  //   component: FourplusIntroduce05
  // },
  // {
  //   path: basePath+'/fifteenthIntroduce',
  //   name: 'fifteenthIntroduce',
  //   component: FifteenthIntroduce
  // },
  // {
  //   path: basePath+'/smartBeautyIntroduce',
  //   name: 'smartBeautyIntroduce',
  //   component: SmartBeautyIntroduce
  // },
  {
    path: basePath+'/nourishIntroduce',
    name: 'nourishIntroduce',
    component: NourishIntroduce
  },
];

const ADD_CART_POPUP_ARO_ROUTES = [
  {
    path: '*',
    name: 'popupAddInAroCart',
    component: PopupAddInAroCart
  },
];


const SEARCH_PRODUCT_LIST = [
  {
    path: '*',
    name: 'searchProductList',
    component: SearchProductList
  },
];

var linkRoutes = MAIN_ARO_ROUTES;
switch(artConfig.integrationMode){
  case 1:
    linkRoutes = ADD_CART_POPUP_ARO_ROUTES;
    break;
  case 2:
    linkRoutes = SEARCH_PRODUCT_LIST;
    break;
  default:
    linkRoutes = MAIN_ARO_ROUTES;
    break;
}

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: linkRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js